import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { MenuComponent } from '@go-modules/components/menus/menu/menu.component';
import { ArchivedItem, ArchivedItemType } from '@go-modules/interfaces/archived/archived.interface';

@Component({
	selector: 'ngx-archive-card',
	templateUrl: './archive-card.component.html',
	styleUrls: ['./archive-card.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class NgxArchiveCardComponent {
	@ViewChild(MenuComponent) public menuComponent: MenuComponent;
	@ViewChild('cardContainer', {read: ElementRef}) public cardContainer: ElementRef;
	@Input() public archive: any;
	public RESOURCE_TYPE = ArchivedItemType;
	public archiveNameTruncated = null;

	constructor (private cdr: ChangeDetectorRef) {}

	public openMenu (event: MouseEvent) {
		// open browser menu on shift right click
		if (event.button === 2 && event.shiftKey) {
			return;
		}
		event.preventDefault();
		this.menuComponent.openMenu(event, this.cardContainer.nativeElement);
	}

	public getNameList (archive: ArchivedItem) {
		return archive.presenters.map((item) => `${item.first_name} ${item.last_name}`);
	}

	public handleTruncatedChange (archiveNameTruncated: boolean) {
		this.archiveNameTruncated = archiveNameTruncated;
		this.cdr.detectChanges();
	}
}
